/**
 * create on 2019.08.15
 * 设置租户功能模块
 */
'use strict';
angular.module('setBillingModule', ['H5ToolBindAccountServiceModule'])
    .controller('setBillingModuleCtrl', ['$scope', '$q', '$modalInstance', 'item', 'trsHttpService', 'modalDialog', '$validation', 'tManageMentService',
        function($scope, $q, $modalInstance, item, trsHttpService, modalDialog, $validation, tManageMentService) {
            initStatus();
            initData();

            /**
             * [initData description]初始化数据
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                // 一进入就需要获取一下H5用户的请求
                requestH5account().then(function() {
                    var params = {
                        'serviceid': 'mlf_billing',
                        'methodName': 'queryModulesByTenantOfEdit',
                        'TenantId': $scope.status.TENANTID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'GET').then(function(result) {
                        turnRemark(result);
                        $scope.status.items = result;
                    });
                });
            }

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    childTableShowFlag: true,
                    items: [],
                    TENANTID: item.TENANTID,
                    allTimeArr: [],
                };
                // 这是给H5工具提供的数据
                $scope.h5Data = {
                    h5DataBindUrl: '',
                    h5DataToken: '',
                };
                $scope.customConfig2 = {
                    drops: 'up', // 弹框方向
                };

            }

            /** [cancel description]关闭弹窗 */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [confirm description] 函数名称
             * @param  {[type]}  [description]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                let deffer = $q.defer();
                $validation.validate($scope.billingForm).success(function() {
                    subBilling();
                    deffer.resolve();
                }).error(function() {
                    modalDialog.alertType('请检查填写项!', '', 'error', false);
                });
                return deffer.promise;
            };

            /**
             * [h5toolbindaccount description]h5工具绑定账号方法
             *
             * @param   {[type]}  item  [success description]
             *
             * @return  {[type]}           [return description]
             */
            $scope.h5toolbindaccount = function() {
                tManageMentService.bindTip(item).then(function(data) {
                    requestH5account().then(
                        function() {
                            if ($scope.h5Data.h5DataToken !== '') {
                                modalDialog.alertType('绑定成功', '', 'success', false);
                            } else {
                                modalDialog.alertType('绑定失败，请重试', '', 'error', false);
                            }
                        },
                    );
                });
            };

            /**
             * [requestH5account description]取消H5绑定
             *
             * @return  {[type]}  [return description]
             */
            $scope.cancelh5toolbindaccount = function() {
                let deffer = $q.defer();
                let params = {
                    serviceid: 'mlf_eqxiuaccount',
                    methodname: 'releaseEqxiuAccount',
                    TenantId: $scope.status.TENANTID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(result) {
                    $scope.h5Data.h5DataBindUrl = '';
                    $scope.h5Data.h5DataToken = '';
                    // if (result.TYPE === '4') {
                    //     $scope.h5Data.h5DataBindUrl = result.DETAIL;
                    // } else {
                    //     $scope.h5Data.h5DataToken = result.DETAIL;
                    // }
                    // requestH5account();
                    deffer.resolve();
                });
                return deffer.promise;
            };

            /**
             * [requestH5account description]刷新H5绑定的用户名
             *
             * @return  {[type]}  [return description]
             */
            function requestH5account() {
                let deffer = $q.defer();
                let params = {
                    serviceid: 'mlf_eqxiuaccount',
                    methodname: 'queryEqxiuAccountByTenantId',
                    TenantId: $scope.status.TENANTID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(result) {
                    if (result.TYPE === '4') {
                        $scope.h5Data.h5DataBindUrl = result.DETAIL;
                    } else if (result.TYPE === '3') {
                        $scope.h5Data.h5DataToken = result.DETAIL;
                    } else {
                        modalDialog.alertType('获取H5用户信息失败', '', 'error', false);
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [methodName description] 函数名称
             * @param  {[type]}  [description]
             * @return {[type]} [description]
             */
            function subBilling() {
                let deffer = $q.defer();
                detectTimeArr();
                let params = {
                    serviceid: 'mlf_billing',
                    methodname: 'saveBillingModuleOfTenant',
                    BillingModules: JSON.stringify($scope.status.allTimeArr),
                    TenantId: $scope.status.TENANTID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(result) {
                    modalDialog.alertType('修改成功', '', 'success', false);
                    $modalInstance.dismiss();
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [turnRemark description] 转化备注
             * @param  {[type]}  [description]
             * @return {[type]} [description]
             */
            function turnRemark(result) {
                var d = new Date();
                result.forEach((item) => {
                    if (item.CHILDREN) {
                        item.CHILDREN.forEach((val) => {
                            if (val.REMARKS == '-') {
                                val.REMARKS = '';
                            }
                            val.STARTTIME = val.STARTTIME ? val.STARTTIME : 'today';
                        });
                    } else {
                        if (item.REMARKS == '-') {
                            item.REMARKS = '';
                        }
                        item.STARTTIME = item.STARTTIME ? item.STARTTIME : 'today';
                    }
                });
            }

            /**
             * [detectTimeArr description]  检出 allTimeArr 数组,提交数据用到
             */
            function detectTimeArr() {
                $scope.status.allTimeArr = [];
                $scope.status.items.forEach((item, index) => {
                    if (item.CHILDREN) {
                        item.CHILDREN.forEach((itm) => {
                            if (itm.STATUS == 1) {
                                var obj = {
                                    'BillingModuleId': itm.BILLINGMODULEID,
                                    'StartTime': itm.STARTTIME ? itm.STARTTIME : '',
                                    'EndTime': itm.ENDTIME ? itm.ENDTIME : '',
                                    'ParentId': itm.PARENTID,
                                    'Remarks': itm.REMARKS ? itm.REMARKS : '',
                                    'UseDetailedList': '-',
                                    'TenantId': $scope.status.TENANTID,
                                };
                                $scope.status.allTimeArr.push(obj);
                            }
                        });
                    } else {
                        if (item.STATUS == 1) {
                            var obj = {
                                'BillingModuleId': item.BILLINGMODULEID,
                                'StartTime': item.STARTTIME ? item.STARTTIME : '',
                                'EndTime': item.ENDTIME ? item.ENDTIME : '',
                                'ParentId': item.PARENTID,
                                'Remarks': item.REMARKS ? item.REMARKS : '',
                                'UseDetailedList': '-',
                                'TenantId': $scope.status.TENANTID,
                            };
                            $scope.status.allTimeArr.push(obj);
                        }
                    }
                });
            }
        },
    ]);
